export * from "./create-patient.guard";
export * from "./create-test-order.guard";



// WEBPACK FOOTER //
// ./src/app/shared/guard/physician-portal/route-guards/index.ts